import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {IdentificationServiceRequest} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormOfficialId from './InnerFormOfficialId';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';
import {Messages} from 'commons/constants';

OfficialIdForm.propTypes = {
    foreign: PropTypes.bool.isRequired,
    auxLegalRepresentative: PropTypes.any,
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof OfficialIdForm.propTypes>,
    IdentificationServiceRequest
>({
    mapPropsToErrors: () => {
        return {
            identificationType: '',
            identificationNumber: '',
            kycId: '',
            otherIdentificationType: '',
            otherIdentificationNumber: '',
            issuingAuthority: '',
            dniFront: '',
            dniBack: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxLegalRepresentative} = props;
        if (auxLegalRepresentative) {
            return {
                identificationType: auxLegalRepresentative.identificationType || '',
                identificationNumber: auxLegalRepresentative.identificationNumber || '',
                kycId: auxLegalRepresentative.kycId || 0,
                otherIdentificationType: auxLegalRepresentative.otherIdentificationType || '',
                otherIdentificationNumber: auxLegalRepresentative.otherIdentificationNumber || '',
                issuingAuthority: auxLegalRepresentative.issuingAuthority || '',
                dniFront: auxLegalRepresentative.dniFront || '',
                dniBack: auxLegalRepresentative.dniBack || '',
            };
        } else {
            return {
                identificationType: '',
                identificationNumber: '',
                kycId: 0,
                otherIdentificationType: '',
                otherIdentificationNumber: '',
                issuingAuthority: '',
                dniFront: '',
                dniBack: '',
            };
        }
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: IdentificationServiceRequest, props) => {
        const errors: FormikErrors<IdentificationServiceRequest> = {};
        formValidator(props.fields, errors, values);
        if (!props.foreign) {
            if (!values.dniFront) {
                errors.dniFront = Messages.DNI_FRONT_MISSING;
            }
            if (!values.dniBack && values.identificationType === '1') {
                errors.dniBack = Messages.DNI_BACK_MISSING;
            }
        }
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormOfficialId);

function OfficialIdForm(props: InferPropTypes<typeof OfficialIdForm.propTypes>) {
    const {submitHandler, fields, auxLegalRepresentative, foreign} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            foreign={foreign}
            submitHandler={submitHandler}
            auxLegalRepresentative={auxLegalRepresentative}
        />
    );
}

export default OfficialIdForm;
